import { AppState } from '@/vuex/store';
import { BROADCAST, broadcast } from '@/mass/models/Broadcast';
import CustomerRemark from '../../../customer/models/CustomerRemark';

export default {
  UPDATE_TIME_TYPE: (state: AppState, timeType: number) => {
    state.massState.broadcast.timeType = timeType;
  },
  UPDATE_INTERACT_TYPE: (state: AppState, interactType: number) => {
    state.massState.broadcast.interactType = interactType;
  },
  UPDATE_INTERACT_TYPE_IS_ALL: (state: AppState, interactTypeIsAll: number) => {
    state.massState.broadcast.interactTypeIsAll = interactTypeIsAll;
  },
  UPDATE_EXPECT_COUNT: (state: AppState, count: number) => {
    state.massState.broadcast.expectCount = count;
  },
  UPDATE_BROADCAST_TEXT: (state: AppState, text: string) => {
    state.massState.broadcast.contentType = BROADCAST.CONTENT_TYPE.TEXT;
    state.massState.broadcast.text = text;
  },
  UPDATE_BROADCAST_PROP_CONFIGS: (state: AppState, item: any) => {
    state.massState.broadcast.propConfigs = item;
  },
  UPDATE_BROADCAST_COUPON: (state: AppState, item: any) => {
    state.massState.broadcast.contentType = BROADCAST.CONTENT_TYPE.COUPON;
    state.massState.broadcast.couponText = undefined;
    state.massState.broadcast.cardId = item.cardId;
  },
  UPDATE_BROADCAST_COUPON_TEXT: (state: AppState, couponText: string) => {
    state.massState.broadcast.contentType = BROADCAST.CONTENT_TYPE.COUPON;
    state.massState.broadcast.cardId = undefined;
    state.massState.broadcast.couponText = couponText;
  },
  UPDATE_BROADCAST_NEWS: (state: AppState, item: any) => {
    state.massState.broadcast.contentType = BROADCAST.CONTENT_TYPE.NEWS;
    state.massState.broadcast.newsId = item.parentNews.id;
  },
  UPDATE_BROADCAST_IMAGE: (state: AppState, item: any) => {
    state.massState.broadcast.contentType = BROADCAST.CONTENT_TYPE.IMAGE;
    state.massState.broadcast.mediaId = item.mediaId;
    state.massState.broadcast.imageId = item.id;
    state.massState.broadcast.imageUrl = item.url;
  },
  UPDATE_BROADCAST_REMARK: (state: AppState, remarks: CustomerRemark[]) => {
    state.massState.broadcast.remarkSet = remarks;
  },
  INIT_BROADCAST: (state: AppState) => {
    state.massState.broadcast = JSON.parse(JSON.stringify(broadcast));
  },
};
